<div class="ds-input-wrap db-create-website-install-websites-list__toggle">
  <span class="ds-input-label">{{ 'text_website' | dbText}}</span>
  <input type="text" class="ds-input" [placeholder]="'text_selectSite' | dbText" (focus)="toggled = true">
  <span *ngIf="!selectedWebsite && formSubmitted" class="ds-input-error-msg">{{'text_selectSite' | dbText}}.</span>
  <i class="db-icon db-icon-ds-arrow-small" (click)="toggleDropdown()" [ngClass]="{'toggled': toggled}"></i>
</div>

<ul class="db-create-website-install-websites-list__list" *ngIf="toggled">
  <li *ngFor="let website of websites; let i = index" (click)="selectWebsite(website.id)">
    <div class="db-create-website-install-websites-list__thumb mr10"
         [ngStyle]="{backgroundImage: 'url(&quot;'+
                         (website?.screenshot && !website?.isLocalhost ?  'data:image/jpg;base64,' + website?.screenshot
                         : '../../assets/images/common/no_screenshot.svg') + '&quot;)'}">
    </div>
    <div class="db-create-website-install-websites-list__info">
      <div>
        <h1 [innerHTML]="website?.title"></h1>
        <i class="db-icon db-icon-ds-checkmark-bg" *ngIf="website?.domain_hash"></i>
      </div>
      <a [href]="website?.site_url" target="_blank" rel="noopener">{{website?.site_url}}</a>
    </div>
  </li>
</ul>

<div *ngIf="!!selectedWebsite" class="db-create-website-install-websites-list__selected-website">
  <div class="db-create-website-install-websites-list__thumb mr10"
       [ngStyle]="{backgroundImage: 'url(&quot;'+
                         (selectedWebsite?.screenshot && !selectedWebsite?.isLocalhost ?  'data:image/jpg;base64,' + selectedWebsite?.screenshot
                         : '../../assets/images/common/no_screenshot.svg') + '&quot;)'}">
  </div>
  <div class="db-create-website-install-websites-list__info">
    <div>
      <h1 [innerHTML]="selectedWebsite?.title"></h1>
      <i class="db-icon db-icon-ds-checkmark-bg" *ngIf="selectedWebsite.domain_hash"></i>
    </div>
    <a [href]="selectedWebsite?.site_url" target="_blank" rel="noopener">{{selectedWebsite?.site_url}}</a>
  </div>
  <ds-dropdown class="mr10"
               [formControl]="websiteType"
               [dsDropdownWidth]="'140px'"
               [dsDropdownOptions]="dropdownOptions"
               [dsDropdownDisabled]="!selectedWebsite.siblingId"
               (onOptionChoose)="changeWebsiteEnv()"></ds-dropdown>
  <i class="db-icon db-icon-ds-close" (click)="selectWebsite(null)"></i>
</div>
